import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../containers/Layout/Layout";
import {
  loadLocationsAction,
  saveLessonAction,
  addLessonAction,
  getLocations,
  isLoading,
  isSaving,
  getLessons
} from "../../../state/data";
import Loader from "../../atomic/Loader/Loader";
import EditLesson from "../../partials/EditLesson/EditLesson";
import { Route, Switch, useParams, Redirect } from "react-router-dom";

const OneLessonPage = ({ match }) => {
  const locations = useSelector(getLocations);
  const lessons = useSelector(getLessons);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const saving = useSelector(isSaving);
  const { lessonId } = useParams();
  const id = lessonId;
  const [added, setAdded] = useState(false);
  useEffect(() => {
    if (!lessons) {
      dispatch(loadLocationsAction());
    }
  }, []);
  useEffect(() => {
    if (!lessons) {
      return;
    }
    if (!added && !saving && !lessons.filter(l => l.id === id)[0]) {
      setAdded(true);
      dispatch(addLessonAction({ id }));
    }
  }, [lessons, saving, added, lessonId]);
  if (!lessons || loading) {
    return <Loader />;
  }
  const loc = lessons.filter(l => l.id === id)[0];
  if (!loc) {
    return <Loader />;
  }
  return (
    <EditLesson
      lesson={loc}
      locations={locations}
      saving={saving}
      save={(loc, field) => dispatch(saveLessonAction(loc, field))}
    />
  );
};

export default OneLessonPage;
